import Add from '@/assets/Add'
import { useToastNotification } from '@/components/compliance-assistant/ToastNotification'
import Tooltip from '@/components/compliance-assistant/Tooltip'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { formatChileanRut, validateRut } from '@/lib/utils'
import React, { useState } from 'react'

export default function AddRut({
  addRut,
  disabled,
}: {
  addRut: (rut: string) => void
  disabled: boolean
}) {
  const { triggerToast } = useToastNotification()
  const [rut, setRut] = useState<string>('')
  const [open, setOpen] = useState(false)
  const [error, setError] = useState<boolean>(false)

  const handleRutChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRut(formatChileanRut(e.target.value))
  }

  const handleAddRut = () => {
    setError(false)
    if (!validateRut(rut)) {
      triggerToast({ message: 'RUT inválido' })
      setError(true)
      return
    }
    addRut(rut)
    setRut('')
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger disabled={disabled} asChild>
        <Tooltip content="Cargar">
          <Button
            className="px-2"
            variant="ghost"
            type="button"
            disabled={disabled}
            onClick={() => setOpen((prev) => !prev)}
          >
            <Add />
          </Button>
        </Tooltip>
      </PopoverTrigger>
      <PopoverContent className="w-80 bg-white">
        <div className="grid gap-4">
          <div className="grid grid-cols-7 items-center gap-4">
            <Label className="col-span-1">RUT</Label>
            <Input
              className={`col-span-5 h-8 ${error ? 'border-red-500' : ''}`}
              value={rut}
              onChange={handleRutChange}
              onKeyUp={(e) => {
                if (e.key === 'Enter') handleAddRut()
              }}
            />
            <Tooltip content="Cargar RUT">
              <Button
                className="col-span-1 px-2"
                onClick={handleAddRut}
                variant="ghost"
                type="button"
              >
                <Add />
              </Button>
            </Tooltip>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
